<template>
  <BaseButton type="black" small :outlined="true" :class="$style.logout" @click.native="logout">
    <IconSelect icon="lock" height="18" width="18" />

    <span :class="$style.text">{{ $t('app.logout') }}</span>
  </BaseButton>
</template>

<script>
import { mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'NavigationLogoutItem',
  components: {
    IconSelect,
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      appLogoutUrl: APP_GETTER.LOGOUT_URL,
    }),
  },
  methods: {
    logout() {
      // Register Service Worker in case no Service Worker is registered
      navigator.serviceWorker.getRegistrations().then(registrations => {
        if (!registrations.length) {
          window.registerServiceWorker().then(() => {
            window.location.replace(this.appLogoutUrl)
          })
        } else {
          window.location.replace(this.appLogoutUrl)
        }
      })
    },
  },
}
</script>

<style lang="scss" module>
.logout {
  display: flex;
  align-items: center;
}

.text {
  margin-left: 0.5rem;

  font-weight: var(--font-weight-normal);

  font-size: var(--font-sm);

  line-height: 1;
}
</style>
